import { render, staticRenderFns } from "./Replaces.vue?vue&type=template&id=5a88813a"
import script from "./Replaces.vue?vue&type=script&lang=js"
export * from "./Replaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports